/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-repeated-numbers';
const prefix = `${moduleName}.${componentName}`;

export const placeholderLabel = `${prefix}.placeholderLabel`;

export const ENGLISH = {
    [placeholderLabel]: 'Enter Value(s)',
};
